module.exports = __webpack_public_path__ + "static/img/secondarybeijinligong.8f4e2c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/secondarybeijinligong.jpg
// module id = qBjO
// module chunks = 46